import styled from "styled-components";

import { breakpoints } from  '../../../styles/variables';

export const SItemsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 25rem;
    max-width: 100%;
    flex-wrap: wrap;
    align-tems: center;

    @media (min-width: ${ breakpoints.medium }) {
        width: 56rem;
    }

    @media (min-width: ${ breakpoints.large }) {
        width: 100%;
    }
`;

export const SItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 25rem;
    margin-bottom: 1.5rem;
`;

export const SIconContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    .svg-icon {
        height: 110px;
        margin-bottom: 15px;
        box-sizing: border-box;
    }
`;

export const SItemDescription = styled.p`
    width: 100%;
    max-width: 100%;
    text-align: center;
    font-family: "Helvetica", sans-serif;
    font-size: 1.6rem;
    line-height: 2.4rem;

    span {
        font-family: 'Gilroy', sans-serif;
        font-weight: 800;
        font-size: 2.5rem;
    }
`;
